import { slugify } from "underscore.string";

export default value =>
  slugify(value.toLowerCase())
    .split("-")
    .join("_");
